<template>
  <div>
    <BaseLabel :label="_labelWithSuffix"></BaseLabel>
    <component
      v-bind="$attrs"
      v-on="$listeners"
      :is="component"
      :placeholder="_placeholder"
      :error-messages="errorMessages"
      :index-service-params="computedIndexServiceParams"
      @object:change="changeParams"
    />
  </div>
</template>

<script>
export default {
  name: 'IndexFilterField',
  props: {
    /* Field definitions - see @/constants/filterNamesFieldsMap.js */
    name: {
      type: String,
      required: true,
    },
    type: {
      // TO_DEPRECATE: Provides compatibility with old type syntax.
      // Remove when all filters use a definition in @/constants/filterNamesFieldsMap.js
      type: String,
      default: 'text',
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    component: {
      // render createElement() first argument, html tag String or (async) component import Object/Function
      type: [String, Object, Function],
      default: 'div',
    },
    validationStatus: {
      // $v property for this field
      type: Object,
    },
    relatedFilters: {
      type: Array,
      default: () => [],
    },
    indexServiceParams: {
      // params for index service, used to pass filter values to the index service
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      searchInputParams: {
        filter: {}
      },
    };
  },
  computed: {
    _label() {
      const l = this.$t(this.label || `filters.${this.name}`);
      if (this.label && l.includes(' | ')) {
        return this.$tc(this.label, 1);
      }
      return l;
    },
    _placeholder() {
      return this.$t(this.placeholder) || this._label;
    },
    errorMessages() {
      return this.$tve(this.validationStatus);
    },
    _labelWithSuffix() {
      let suffix = this.validationStatus.$params.required ? ' *' : '';
      return this._label + suffix;
    },
    computedIndexServiceParams() {
      const baseParams = { ...this.indexServiceParams };
      const searchParams = { ...this.searchInputParams };
      
      // Merge filter objects properly
      if (baseParams.filter || searchParams.filter) {
        return {
          ...baseParams,
          ...searchParams,
          filter: {
            ...(baseParams.filter || {}),
            ...(searchParams.filter || {})
          }
        };
      }
      
      return {
        ...baseParams,
        ...searchParams
      };
    },
  },
  methods: {
    changeParams(object) {
      this.$emit('change:search', {scope: this.name, id: object?.id})
    },
    updateParams(filter, id) {
      const relatedFilter = this.relatedFilters.find(x => x['filter'] === filter);
      if (!relatedFilter) return;
      if (id) {
        this.$set(this.searchInputParams.filter, relatedFilter.scope, id);
      } else {
        this.$delete(this.searchInputParams.filter, relatedFilter.scope);
      }
    }
  },
};
</script>
